export const config = {
  BaseUrl: import.meta.env.VITE_APP_BASE_URL,
  AppName: import.meta.env.VITE_APP_NAME,
  AppScript: import.meta.env.VITE_APP_GOOGLE_SCRIPT_URL,
};
